import { DataTableImage, Dialog } from "@appretio/ui-kit";
import { CustomCellRendererProps } from "ag-grid-react";
import { useState } from "react";

export const TABLE_IMAGE_HEIGHT = 140;

export function DataTableImageWithDialog({
  value,
  data,
  ...rest
}: CustomCellRendererProps) {
  const [open, setOpen] = useState(false);

  // Handle case where data is undefined (loading row in infinite scroll)
  if (!data) {
    return null;
  }

  return (
    <>
      <DataTableImage
        value={value}
        data={data}
        width="auto"
        onClick={() => setOpen(true)}
        {...rest}
      />

      <Dialog open={open} onOpenChange={setOpen} size="md">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "48px"
          }}
        >
          <img
            src={data.appretio_picture_url || data.appretio_thumbnail_url}
            alt={`${data.style_name} - ${data.style_colour}`}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "70vh",
              objectFit: "contain"
            }}
          />
        </div>
      </Dialog>
    </>
  );
}
